// extracted by mini-css-extract-plugin
export default {"container":"V4NKlU_DvGVZa6bMjkuk","history":"S_JW4iVEaU9IwG66qA_R"};